import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { SistemaProyectoModels } from '../../../pojos/sistema-proyectos.model';
import { CallHttp } from '../../../services/call-http.services';
import { DialogService } from '../../../services/dialog.service';
import { WebServices } from '../../../services/WebServices';
import { InfoUserService } from '../../../utilities/info-user/info-user.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  private objDataUrl: SistemaProyectoModels.IDataUrl = null;
  private Base64Data: string = null;
  @Input() activeTodoList: boolean = false;
  @Input() activeCarteraProy: boolean = false;
  @Input() activeMantProy: boolean = false;
  @Input() activeNewProject: boolean = false;
  @Input() activeSponsor: boolean = false;
  @Input() activeReportSuperUsuario: boolean = false;
  @Input() activeMantenimiento: boolean = false;
  @Input() modalActive: boolean = false;
  @Input() RolUsuario: SistemaProyectoModels.TypeEquisVm = null;
  @Input() disabled: boolean = false;

  IdUsuario: string = null;
  showDropdown = false;
  //NombreUsuario: string = null;
  //IdSistema: string = null;

  constructor(
    private rutaActiva: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
    private callHttp: CallHttp,
    public infoUsuario: InfoUserService
  ) {}

  hoverDropdown(show: boolean): void {
    if (!this.disabled && !this.showDropdown) {
    }
  }

  toggleDropdown(): void {
    if (!this.disabled) {
      this.showDropdown = !this.showDropdown;
    }
  }

  ngOnInit() {
    if (isNullOrUndefined(this.infoUsuario.rolepersona)) {
      this.getData();
    }
  }

  getData(): any {
    this.Base64Data = this.rutaActiva.snapshot.params['dataUsuario'];
    this.objDataUrl = JSON.parse(atob(this.Base64Data));
    this.IdUsuario = this.objDataUrl.IdUsuario;
    if (isNullOrUndefined(this.infoUsuario.rolepersona)) {
      this.getRolByUser(this.IdUsuario);
    }
    return this.objDataUrl;
  }
  getRolByUser(usuarioId: string) {
    if (isNullOrUndefined(usuarioId)) return;

    this.callHttp
      .httpGet<SistemaProyectoModels.IListaPersonasPorRol>(
        WebServices.GetRolesByPersonaId,
        `PersonaId=${usuarioId}`
      )
      .subscribe((response) => {
        if (this.toType(response) == 'object' && response.Rol != null) {
          this.RolUsuario = response.Rol;
          this.infoUsuario.setPersona(usuarioId, response.Rol);
        }
      });
  }

  toType(obj) {
    return {}.toString
      .call(obj)
      .match(/\s([a-z|A-Z]+)/)[1]
      .toLowerCase();
  }

  Redirigir() {
    if (this.disabled) return;
    let base64 =
      'eyJJZFNpc3RlbWEiOiIyMCIsIklkVXN1YXJpbyI6IjdiOTQ2NmE2LTQ5NzItNDRlOC05NGRlLTE4NGI2NWM4Y2JkZiIsIk5vbWJyZVVzdWFyaW8iOiJDw6lzYXIgQm9uaWxsYSIsIkNvcnJlbGF0aXZvUHJveWVjdG8iOiIifQ%3D%3D';
    if (
      this.infoUsuario.rolepersona.Value === 3 ||
      this.infoUsuario.rolepersona.Value === 2 ||
      this.infoUsuario.rolepersona.Value === 1 ||
      this.infoUsuario.rolepersona.Value === 6
    ) {
      let data = this.getData();
      if (data != null) {
        let obj: SistemaProyectoModels.IDataUrl = {
          IdSistema: data.IdSistema,
          IdUsuario: data.IdUsuario,
          NombreUsuario: data.NombreUsuario,
          CorrelativoProyecto: '',
        };
        let objJson: string = JSON.stringify(obj);
        let objBase64: string = btoa(objJson);
        this.router.navigate(['/crearproyecto/index/' + objBase64]);
      }
    } else {
      this.dialogService.NotificacionWarning(
        'Lo sentimos no tienes permisos para crear un proyecto nuevo.',
        false
      );
    }
  }

  RedirigiToDoList() {
    if (this.disabled) return;
    //this.Base64Data = this.rutaActiva.snapshot.params["dataUsuario"];
    let data = this.getData();
    if (data != null) {
      let obj: SistemaProyectoModels.IDataUrl = {
        IdSistema: data.IdSistema,
        IdUsuario: data.IdUsuario,
        NombreUsuario: data.NombreUsuario,
        CorrelativoProyecto: '',
      };
      let objJson: string = JSON.stringify(obj);
      let objBase64: string = btoa(objJson);
      this.router.navigate(['/todolist/index/' + objBase64]);
    }
  }

  RedirigirCarteraProyectos() {
    if (this.disabled) return;
    let data = this.getData();
    if (data != null) {
      let obj: SistemaProyectoModels.IDataUrl = {
        IdSistema: data.IdSistema,
        IdUsuario: data.IdUsuario,
        NombreUsuario: data.NombreUsuario,
        CorrelativoProyecto: '',
      };

      let objJson: string = JSON.stringify(obj);
      let objBase64: string = btoa(objJson);
      this.router.navigate(['/carteraproyectos/index/' + objBase64]);
    }
  }

  RedirigirReporteSuperUsuario() {
    if (this.disabled) return;
    let data = this.getData();
    if (data != null) {
      // Verifica si el rol del usuario es 1
      if (this.infoUsuario.rolepersona.Value === 1) {
        let obj: SistemaProyectoModels.IDataUrl = {
          IdSistema: data.IdSistema,
          IdUsuario: data.IdUsuario,
          NombreUsuario: data.NombreUsuario,
          CorrelativoProyecto: '',
        };
        let objJson: string = JSON.stringify(obj);
        let objBase64: string = btoa(objJson);
        this.router.navigate(['/reportesuperusuario/index/' + objBase64]);
      } else {
        this.dialogService.NotificacionWarning(
          'Lo sentimos, no tienes permisos para acceder a Reporte Super Usuario.',
          false
        );
      }
    }
  }

  RedirigirMantenimiento() {
    if (this.disabled) return;
    let data = this.getData();
    if (data != null) {
      if (
        this.infoUsuario.rolepersona.Value === 1 ||
        this.infoUsuario.rolepersona.Value === 6
      ) {
        let obj: SistemaProyectoModels.IDataUrl = {
          IdSistema: data.IdSistema,
          IdUsuario: data.IdUsuario,
          NombreUsuario: data.NombreUsuario,
          CorrelativoProyecto: '',
        };
        let objJson: string = JSON.stringify(obj);
        let objBase64: string = btoa(objJson);
        this.router.navigate(['/mantenimiento/index/' + objBase64]);
      } else {
        this.dialogService.NotificacionWarning(
          'Lo sentimos, no tienes permisos para acceder a Mantenimiento.',
          false
        );
      }
    }
  }

  RedirigirMantProyectos() {
    if (this.disabled) return;
    let data = this.getData();
    if (data != null) {
      let obj: SistemaProyectoModels.IDataUrl = {
        IdSistema: data.IdSistema,
        IdUsuario: data.IdUsuario,
        NombreUsuario: data.NombreUsuario,
        CorrelativoProyecto: '',
      };
      let objJson: string = JSON.stringify(obj);
      let objBase64: string = btoa(objJson);
      this.router.navigate(['/mantenimientoproyecto/index/' + objBase64]);
    }
  }
  RedirigirSponsorACrearObjetivos() {
    if (this.disabled) return;
    if (this.infoUsuario.rolepersona.Value !== 4) {
      let data = this.getData();
      if (data != null) {
        let obj: SistemaProyectoModels.IDataUrl = {
          IdSistema: data.IdSistema,
          IdUsuario: data.IdUsuario,
          NombreUsuario: data.NombreUsuario,
          CorrelativoProyecto: '',
        };
        let objJson: string = JSON.stringify(obj);
        let objBase64: string = btoa(objJson);
        this.router.navigate(['/sponsor/index/' + objBase64]);
      }
    } else {
      this.dialogService.NotificacionWarning(
        'Lo sentimos no tienes permisos para navegar a Sponsor y Objetivos Estratégicos.',
        false
      );
    }
  }
}
